import React from "react";
import { useField, useFormikContext } from "formik";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";

interface InputSliderProps {
  name: string;
  step?: number;
  max?: number;
  min?: number;
  handleChange?: (value: number) => void;
}

const InputSlider: React.FC<InputSliderProps> = ({
  name,
  step,
  max,
  min,
  handleChange,
}) => {
  const [field] = useField(name);
  const { setFieldValue } = useFormikContext();

  const onChange = (value: number): void => {
    setFieldValue(name, value);
    if (handleChange) {
      handleChange(value);
    }
  };

  return (
    <Slider
      min={min}
      max={max}
      step={step}
      defaultValue={100}
      value={field.value || 100}
      onChange={(e) => {
        onChange(e as number);
      }}
    />
  );
};

export default InputSlider;